/**
 * Статусы бэкенда
 */
export namespace ResponseStatuses {
  export enum Success {
    OK = 200,
    CREATED = 201,
    UPDATED = 202,
    RESET_CONTENT = 205,
  }

  export enum Fail {
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    CONFLICT = 409,
    UNPROCESSABLE = 422,
    TOO_MANY_REQUESTS = 429,
    INTERNAL_ERROR = 500,
  }
}

export const fail_responses = Object.values(ResponseStatuses.Fail);
export const success_responses = Object.values(ResponseStatuses.Success);

export const ResponseFailStatusesTranslate: Record<string, string> = {
  [ResponseStatuses.Fail.UNAUTHORIZED]: 'Пользователь не авторизован',
  [ResponseStatuses.Fail.FORBIDDEN]: 'Отсутствуют права доступа',
  [ResponseStatuses.Fail.NOT_FOUND]: 'Элемент не найден',
  [ResponseStatuses.Fail.INTERNAL_ERROR]: 'Внутренняя ошибка сервера',
  [ResponseStatuses.Fail.UNPROCESSABLE]: 'Ошибка валидации',
};
